import {
  SET_ACCEPTED_POLICIES,
  ADD_ACCEPTED_POLICY,
  UPDATE_ACCEPTED_POLICY,
} from "./ActionTypes";

/**
 * Load from localStorage safely
 */
const loadFromStorage = () => {
  try {
    const data = JSON.parse(localStorage.getItem("acceptedPolicies"));
    return Array.isArray(data) ? data : [];
  } catch {
    return [];
  }
};

const initialState = {
  acceptedPolicies: loadFromStorage(),
};

const acknowledgmentsReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_ACCEPTED_POLICIES: {
      localStorage.setItem(
        "acceptedPolicies",
        JSON.stringify(action.payload)
      );

      return {
        ...state,
        acceptedPolicies: action.payload,
      };
    }

    case ADD_ACCEPTED_POLICY: {
      const exists = state.acceptedPolicies.some(
        (p) => p.policyDetails?.policyId === action.payload.policyId
      );

      if (exists) return state;

      const updated = [...state.acceptedPolicies, action.payload];

      localStorage.setItem(
        "acceptedPolicies",
        JSON.stringify(updated)
      );

      return {
        ...state,
        acceptedPolicies: updated,
      };
    }

    case UPDATE_ACCEPTED_POLICY: {
   
      const updated = state.acceptedPolicies.map((p) =>
        p.policyId === action.payload.policyId
          ? {
              ...p,
              accepted: action.payload.accepted,
              acceptedAt: action.payload.acceptedAt,
            }
          : p
      );

      localStorage.setItem(
        "acceptedPolicies",
        JSON.stringify(updated)
      );

      return {
        ...state,
        acceptedPolicies: updated,
      };
    }

    default:
      return state;
  }
};

export default acknowledgmentsReducer;
